import styled from 'styled-components6';
import { AnalyticsTargetLayerAreaProvider } from 'rwl-ui';
import { LgReviewDetails } from './DetailsReview';
import { useBreakpoint } from '../../providers';
import { When } from 'react-if';
import { SplitDetails } from './SplitDetails';
import { TargetLayerArea } from 'rwl-shared/dist/models/analytics';
import { LgJobDetails } from './DetailsJob';
import { useEffect } from 'react';
import { JobDetailsSimilarJobs } from './JobDetailsSimilarJobs';
import { useJob } from '../../fetchers';

const DetailsContainer = styled.div`
    width: 100%;
    padding: var(--rwl-spacing-lg) 0;
    display: grid;
    gap: var(--rwl-spacing-lg);
`;

export const DetailsView = ({
    containerRef,
}: {
    containerRef: React.RefObject<HTMLDivElement>;
}): JSX.Element => (
    <>
        <DetailsLg containerRef={containerRef} />
        <DetailsSm />
    </>
);

const DetailsLg = ({
    containerRef,
}: {
    containerRef: React.RefObject<HTMLDivElement>;
}) => {
    const { isAboveBreakpoint } = useBreakpoint();
    const { job } = useJob();
    useEffect(() => {
        if (containerRef.current) {
            containerRef.current.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }, [job]);

    return (
        <When condition={!!isAboveBreakpoint('xs')}>
            <DetailsContainer>
                <AnalyticsTargetLayerAreaProvider
                    targetLayerArea={TargetLayerArea.JOBS}
                >
                    <LgJobDetails />
                    <LgReviewDetails />
                    <JobDetailsSimilarJobs />
                </AnalyticsTargetLayerAreaProvider>
            </DetailsContainer>
        </When>
    );
};

const DetailsSm = () => {
    const { isBelowBreakpoint } = useBreakpoint();
    return (
        <When condition={isBelowBreakpoint('xs')}>
            <SplitDetails />
        </When>
    );
};
